import { PaginatedRequest } from './pagination.model';
import { SortedRequest } from './sort.model';

enum TripLegSearchMenu {
  RC_TRIPS = 'RCTrips',
  RC_UNATTTESTED_TRIPS = 'RCUnattestedTrips',
  RC_TIER3_UNATTTESTED_TRIPS = 'RCTier3UnattestedTrips',
}

type TripLegSearchRequest = {
  clientBC?: string;
  menu?: TripLegSearchMenu;
  search?: string;
  tripLegReferenceID?: string;
  memberName?: string;
  firstName?: string;
  lastName?: string;
  clientPassengerID?: string;
  transportationProviderID?: number;
  providerName?: string;
  providerAssigned?: boolean;
  driverName?: string;
  pickUpAddress?: string;
  dropOffAddress?: string;
  pickupDateFrom?: string;
  pickupDateTo?: string;
  todayDate?: string;
  tripLegExceptionBCs?: string[];
  tripLegStatusBCs?: string[];
  includeTripLegStatusLogs?: boolean;
  excludingRideshareWillCalls?: boolean;
  isUnderDiscussion?: boolean;
  isDriverAssigned?: boolean;
} & Partial<PaginatedRequest> &
  Partial<SortedRequest>;

export { TripLegSearchMenu };
export type { TripLegSearchRequest };
